import { a3Copy } from "@/components/assignments/a3-copy";
import { GoogleDriveMark } from "@/components/ui/google-drive-mark";
import { safeHref } from "@/lib/safe-href";
import { MATERIAL_ACCESS, type ShownMaterial } from "./brief-materials";

/** The course materials a brief references, in brief order, each opened where it lives. */
export function BriefMaterials({ materials }: { materials: ShownMaterial[] }) {
  if (!materials.length) return null;
  return (
    <section aria-label="Course materials" data-brief-materials className="grid gap-1.5">
      <p className="text-meta font-semibold text-muted-foreground">Course materials</p>
      <ul className="grid gap-2">
        {materials.map(material => {
          // Writers refuse other schemes; a reference frozen before that stays text (lib/safe-href).
          const href = safeHref(material.file_url);
          // A Drive file leads with Drive's mark; a link's host has none (ADR 0040).
          const mark = material.source === "drive" && <GoogleDriveMark mimeType={material.google_drive_mime_type} url={material.file_url} />;
          return (
            <li key={material.position} className="grid">
              {href
                ? <a href={href} target="_blank" rel="noopener noreferrer" dir="auto" className="inline-flex min-h-11 items-center gap-2 text-ui underline underline-offset-4">
                    {mark}{material.title}<span className="sr-only">{a3Copy.opensInANewTab}</span>
                  </a>
                : <span dir="auto" className="inline-flex min-h-11 items-center gap-2 text-ui">{mark}{material.title}</span>}
              <span className="text-meta text-muted-foreground">{href ? MATERIAL_ACCESS[material.source] : a3Copy.thisIsNotAWebAddressSoItCannotBeOpened}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
